/**
 * Descriptions (and other rich fields) are rendered via dangerouslySetInnerHTML.
 * Plain text saved with real newlines (MCP/API) looks fine in Draft.js (soft breaks)
 * but collapses to a single paragraph in read-only HTML views.
 *
 * Convert plain multi-line text to simple HTML; leave structured markup untouched.
 */
export function ensureRenderableHtml(value: string): string {
    const raw = String(value ?? '');
    if (!raw.trim())
        return '';

    // Already has block/break markup — render as-is (WYSIWYG / email intake).
    if (/<(?:p|div|br|li|ul|ol|h[1-6]|table|tr|td|th|blockquote|pre|hr)\b/i.test(raw))
        return raw;

    // No newlines → nothing to preserve for this display bug.
    if (!/[\r\n]/.test(raw))
        return raw;

    // Inline-tagged HTML with soft newlines: keep tags, insert breaks.
    if (/<\/?[a-z][\s\S]*>/i.test(raw))
        return raw.replace(/\r\n|\r|\n/g, '<br>');

    const escaped = raw
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .trim();

    return `<p>${escaped.replace(/\n\n+/g, '</p><p>').replace(/\n/g, '<br>')}</p>`;
}
